import { render, staticRenderFns } from "./custody.vue?vue&type=template&id=45fd5c02&scoped=true&"
import script from "./custody.vue?vue&type=script&lang=js&"
export * from "./custody.vue?vue&type=script&lang=js&"
import style0 from "./custody.vue?vue&type=style&index=0&id=45fd5c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fd5c02",
  null
  
)

export default component.exports